import React, { useRef } from 'react'
import { Box } from '@mui/material'

import { analyzerCarPick, responseData, tableTabSelected } from 'Pages/AnalyzersV2/@signals'
import AnalyzerCarField from './AnalyzerCarField'
import CarPickLine from './CarPickLine'


/** The second row of the price table's header (UX Obs. 2): the Cars field and its line (CU-869fmpqfm) */
export default function CarPickRow({ onPick, isPosition = false }) {
	const field = useRef(null)
	const open = () => field.current?.querySelector('input')?.click()
	return <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%', minWidth: 0 }}>
		<Box ref={field} data-tour-id="tour-car-pick" sx={{ width: 300, flexShrink: 0, '& .MuiTypography-root:empty': { display: 'none' } }}>
			<AnalyzerCarField pick={analyzerCarPick.value} onPick={onPick}/>
		</Box>
		<CarPickLine pick={analyzerCarPick.value} resolved={responseData.value?.carPick} tab={tableTabSelected.value}
			mix={responseData.value?.carsMix} isPosition={isPosition} onOpen={open}/>
	</Box>
}
